import { useEffect } from "react";
import { useCountUp } from "@/hooks/useCountUp";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function CountUpNumber({ target, duration = 1800, className = "" }) {
  const [ref, revealed] = useScrollReveal(0.3);
  const { value, start } = useCountUp(target, duration, true);

  useEffect(() => {
    if (revealed) start();
  }, [revealed, start]);

  return (
    <span ref={ref} className={className}>
      {value}
    </span>
  );
}
